"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minMax = exports.remap = exports.wait = exports.range = void 0;
var range = function (start, stop, step) {
    return Array.from({ length: (stop - start) / step + 1 }, function (_, i) { return start + i * step; });
};
exports.range = range;
var wait = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.wait = wait;
var remap = function (n, input, output) {
    return ((n - input.min) * (output.max - output.min)) / (input.max - input.min) +
        output.min;
};
exports.remap = remap;
var minMax = function (tuple) {
    return __spreadArray([], tuple).sort(function (a, b) { return a - b; });
};
exports.minMax = minMax;
